import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { EstructuraFisicaPecuaria } from '../_models/estructura-fisica-pecuaria';

@Injectable({
  providedIn: 'root'
})
export class EstructuraFisicaPecuariaService {
  private rutServicio = AppSettings.rutServiciosRG + '/api/estructurasFisicasPecuarias/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as EstructuraFisicaPecuaria[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as EstructuraFisicaPecuaria ) );
  }

  listadoPorEstructuraFisica( id: string ) {
    return this.httpClient.get( this.rutServicio+'estructuraFisica/' + id ).pipe( map( res => res as EstructuraFisicaPecuaria[] ) );
  }

  crear( regCrear: EstructuraFisicaPecuaria ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as EstructuraFisicaPecuaria ) );
  }

  actualizar( regActualizar: EstructuraFisicaPecuaria ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: EstructuraFisicaPecuaria[] ) {
    regActualizar.map( ( s: EstructuraFisicaPecuaria ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + 'bulk', regActualizar ).pipe( map( res => res as EstructuraFisicaPecuaria[] ) );
  }
}
